import React from 'react';
import './PopularIntegrations.css';

const PopularIntegrations = () => {
  const integrations = [
    'Workday',
    'SAP',
    'Salesforce',
    'Microsoft Teams',
    'Slack',
    'Zoom',
    'Okta',
    'Azure AD',
    'LinkedIn Learning',
    'Coursera',
    'Zoom',
    'Google Workspace',
  ];

  return (
    <section className="popular-integrations-wrapper">
      <div className="popular-integrations-container">
        <div className="popular-integrations-card">
          <h2 className="popular-integrations-title">Popular Integrations</h2>
          <p className="popular-integrations-subtitle">
            Connect with the tools your organization already uses
          </p>

          <div className="integrations-tags">
            {integrations.map((integration, index) => (
              <span key={index} className="integration-tag">
                {integration}
              </span>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default PopularIntegrations;
